export default "__VITE_ASSET__DD49DDM7__"